<template>
  <div class="container" style="overflow: hidden;">
    <div id="newCharts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core';
import { TitleComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([TitleComponent, PieChart, CanvasRenderer, LabelLayout]);
export default {

  data() {
    return {}
  },
  methods: {
    SetEcharts() {
      var chartDom = document.getElementById('newCharts');
      var myChart = echarts.init(chartDom);
      let getWidth = document.body.offsetWidth;
      console.log(getWidth);
      myChart.resize({
        width: getWidth,
        // height: 250
      })
      var option;
      var data = [
        { value: ["2018-07-01 10:00", 0] },
        {  value: ["2018-07-01 10:30", 0] },
        {  value: ["2018-07-01 11:00", 0] },
        {  value: ["2018-07-01 11:30", 0] },
        {  value: ["2018-07-01 12:00", 0] },
        {  value: ["2018-07-01 13:00", 0] },
        { value: ["2018-07-01 13:45", 1] },
        {  value: ["2018-07-01 14:00", 0] },
        {  value: ["2018-07-01 14:30", 0] },
        {  value: ["2018-07-01 15:00", 0] },
        {  value: ["2018-07-01 15:30",0] },
        {  value: ["2018-07-01 16:00", 0] }
      ];
      // var time=['2018-07-01','2018-07-02','2018-07-03','2018-07-04','2018-07-05','2018-07-06','2018-07-07','2018-07-08']
      //时间显示范围

      // 指定图表的配置项和数据
      option = {
        backgroundColor: '#fff',//背景色
        // grid: {
        //   left: 35,
        //   right: 20,
        //   top: 10,
        //   bottom: 40,
        //   show: false
        // },
        // tooltip: {
        //   // trigger: 'axis',
        //   formatter: function (param) {
        //     console.log(param);
        //     return param.value[0] + "<br>" + param.value[1] + "°C";
        //   }
        // },
        xAxis: {
          type: "time",
          splitNumber:20,
          // data:time,
          // splitNumber: 10,
          // axisLabel: {
          //   // rotate: 60,
          //   textStyle: {
          //     fontSize: 8
          //   }
          // }
          axisLabel:{
                formatter:function(value,index){
                    var date = new Date(value);
                    console.log(date);
                    var hour = date.getHours();
                    var minutes = date.getMinutes();
                    if(hour < 10){
                        hour = '0' + hour;
                    }
                    if(minutes < 10){
                        minutes = '0' + minutes;
                    }
                    return hour + ':' + minutes;
                },
                color:'#1B2232'
            }
        },
        yAxis: {
          // min: 35
        },
        // visualMap: {
        //   top: 10,
        //   right: 10,
        //   pieces: [{
        //     gte: 0,
        //     lte: 37,
        //     color: '#4D74FA'
        //   }, {
        //     gt: 37,
        //     lte: 40,
        //     color: '#FA578B'
        //   }],
        //   outOfRange: {
        //     color: '#FA578B'
        //   }
        //   // show : false
        // },
        series: [{
          data: data,
          // markLine: {
          //   silent: true,
          //   data: [{
          //     yAxis: 37
          //   }]
          // },
          type: 'line',
          // smooth: true,
          // markArea: {
          //   data: [
          //     [
          //       { yAxis: 37 },
          //       {}
          //     ]
          //   ],
          //   itemStyle: {
          //     opacity: 0.5,
          //     color: {
          //       type: 'linear',
          //       x: 0,
          //       y: 0,
          //       x2: 0,
          //       y2: 1,
          //       colorStops: [{
          //         offset: 0, color: '#fff' // 0% 处的颜色
          //       },
          //       {
          //         offset: 1, color: '#E7AEAD' // 100% 处的颜色
          //       }
          //       ],
          //       globalCoord: false // 缺省为 false
          //     }
          //   }
          // }
          // areaStyle: {
          //     normal: {
          //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          //             offset: 0,
          //             color: 'rgb(255, 158, 68)'
          //         }, {
          //             offset: 1,
          //             color: '#fff'
          //         }])
          //     }
          // },
        },
        // {
        //   // name: '.anchor',
        //   type: 'line',
        //   showSymbol: false,
        //   data: anchor,
        //   itemStyle: { normal: { opacity: 0 } }, //不绘制该线条
        //   lineStyle: { normal: { opacity: 0 } }
        // }]
        ]
      }
      option && myChart.setOption(option);

    }
  },
  mounted() {
    this.SetEcharts()
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  padding-top: 100px;

  #newCharts {
    margin: 0 auto;
    width: 800px;
    height: 800px;
  }
}
</style>
